module.exports = __webpack_public_path__ + "static/img/huangjiu.99f985e1.png";